import Glide from "@glidejs/glide";
import { siblings } from '@glidejs/glide/src/utils/dom';

document
  .querySelectorAll('.glide-home')
  .forEach((slider) => {
    if (slider) {
      const CustomActiveClass = function (Glide, Components, Events) {
        var Component = {
            mount() {
                this.changeActiveSlide();
            },
    
            changeActiveSlide() {
                let slide = Components.Html.slides[Glide.index];
                slide.classList.remove('is-next', 'is-prev');
                slide.classList.add('is-active');
     
                siblings(slide).forEach((sibling) => {
                    sibling.classList.remove('is-active', 'is-next', 'is-prev');
                });
    
                if(slide.nextElementSibling) {
                  setTimeout(() => {                    
                    slide.nextElementSibling.classList.add('is-next');
                  }, 200);
                }
    
                if(slide.previousElementSibling) {
                  setTimeout(() => {
                    slide.previousElementSibling.classList.add('is-prev');                    
                  }, 200);
                }
            },
        };
    
        Events.on('run', () => {
            Component.changeActiveSlide();
        });
    
        return Component;
    };



      const CustomLength = function(Glide, Components, Events) {
        return {
          mount () {
            Events.emit('slider.length', Components.Sizes.length)
          }
        }
      }
      const config = {
        autoplay: 10000,
        animationDuration: 1000,
        animationTimingFunc: "ease",
        hoverpause:false,
        perView: 1,
        gap: 0,
        swipeThreshold: false,
        dragThreshold: false,
        type: "carousel",
      };
      let glide = new Glide(slider, config)



      glide.on('move', () => {
        // Code to run right before movement transition begins.
        });
        
        glide.on('move.after', () => {
        // Code to run right after movement transition ends.

        });
    
      glide.on('slider.length', (length) => {
        if(length <= 1){
          glide.disable()
        }
      })    
      
      glide.mount({
        CustomLength,
        'CustomActiveClass': CustomActiveClass,
      })
    }
  } ) 